import React from 'react';
import { FaPhone } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { LuClock4 } from "react-icons/lu";
import { FaBook } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { IoMdShare } from "react-icons/io";

//Inconos genericos que usamos por toda la web
const IconosGenerales = (props) => {

  const iconSize = props.contacto ? '27' : props.curso ? '35' : '12';

  const iconStyle = {
    margin: '0px 5px',
    fontSize: `${iconSize}px`,
    color: props.contacto || props.curso ? '#EE805D' : '#4a4a4a'

  };

  const iconStyle2 = {
    margin: '0px 5px',
    fontSize: `17px`,
    color: "#EE805D"
  };
  const iconStyle3 = {
    margin: '0px 5px',
    fontSize: `17px`,
    color: props.hover ? "#EE805D" : "white",
    transition: "color 0.3s ease"
  };

  switch (props.id) {
    case 'telefono':
      return <FaPhone style={iconStyle} />;
    case 'correo':
      return <IoMdMail style={iconStyle} />;
    case 'reloj':
      return <LuClock4 style={iconStyle2} />;
    case 'libro':
      return <FaBook style={iconStyle} />;
    case 'check':
      return <FaCheck style={iconStyle2} />;
    case 'compartir':
      return <IoMdShare style={iconStyle3} />;
    default:
      return null;
  }
};

export default IconosGenerales;
